import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('ClientsReportController', ClientsReportController);

    function ClientsReportController(
        $scope,
        $timeout,
        BulkModeService,
        CompaniesFactory,
        DateService,
        DownloadFileService,
        FormVerificationService,
        LocalStorageService,
        ReportsFactory
    ) {
        var vm = this;
        var paramsTimeout = $timeout();
        init();

        function init() {
            vm.companyEmployee = LocalStorageService.getCompanyEmployee();
            vm.getClients = (companyId, params) => {
                // If CompaniesFactory.readHousingAssociations is not wrapped in that way then
                // this.$http in CompaniesFactory is not defined when paginator
                // try to fetch data.
                return CompaniesFactory.readHousingAssociations(
                    companyId,
                    params
                );
            };
            vm.areClientsAvailable = true;
            vm.getReport = getReport;
            vm.params = { page_size: 50, page: 1 };

            setDefaultDates();
            setWatcher();
        }

        function setWatcher() {
            $scope.$watch(
                function () {
                    return vm.params;
                },
                function () {
                    $timeout.cancel(paramsTimeout);
                    paramsTimeout = $timeout(getClients, 300);
                },
                true
            );
        }

        /**
         * Function sets default dates to first and last day of the
         * previous month.
         */
        function setDefaultDates() {
            var today = new Date();
            today.setMonth(today.getMonth() - 1);

            vm.dateFrom = DateService.createDateFormat(
                DateService.getFirstDayOfTheMonth(today)
            );
            vm.dateTo = DateService.createDateFormat(
                DateService.getLastDayOfTheMonth(today)
            );
        }

        function getReport() {
            ReportsFactory.getClientsReport(
                vm.companyEmployee.organization.party_uuid,
                {
                    date_from: vm.dateFrom,
                    date_to: vm.dateTo,
                    id: vm.batchItems,
                    report_type: vm.params.report_type,
                }
            ).then(
                function (response) {
                    DownloadFileService.downloadFile(response);
                },
                function (response) {
                    FormVerificationService.error(
                        DownloadFileService.transformArrayBufferToJson(
                            response.data
                        ),
                        vm.form
                    );
                }
            );
        }

        function getClients() {
            CompaniesFactory.readHousingAssociations(
                vm.companyEmployee.organization.party_uuid,
                vm.params
            ).then(
                (response) => {
                    vm.areClientsAvailable = true;
                    vm.clients = response.data;
                    vm.totalClients = response.data.count;
                    enableBulkMode();
                },
                (error) => {
                    if (error.status === 404) {
                        vm.areClientsAvailable = false;
                    }
                }
            );
        }

        function enableBulkMode() {
            if (!vm.bulkModeEnabled) {
                BulkModeService.attachBulkModeFunctions(vm, 'clients', 'party_uuid');
                vm.enableBulkMode();
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/analytics/clients-report/clients-report.controller.ts